import React, { useEffect, useState } from "react";
import DataTable from '../../components/DataTablePtBr';
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import api from "../../services/api";
import { showError, showConfirmation, showSuccess } from "../../services/alert";

const TalhaoList = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await api.get("/talhoes");
      setRows(res.data || []);
    } catch (err) {
      showError("Erro ao buscar talhões.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchData(); }, []);

  const handleDelete = async (id) => {
    const ok = await showConfirmation({
      title: "Excluir talhão?",
      text: "Tem certeza que deseja excluir este registro?",
      confirmText: "Sim, excluir",
      cancelText: "Cancelar",
    });
    if (!ok) return;

    try {
      await api.delete(`/talhoes/${id}`);
      showSuccess("Excluido com sucesso.");
      fetchData();
    } catch (err) {
      showError(err?.response?.data?.message || "Erro ao excluir.");
    }
  };

  const columns = [
    { name: "Nome", selector: r => r.nome, sortable: true },
    { name: "Área (ha)", selector: r => r.areaHa, sortable: true, right: true, width: "140px" },
    {
      name: "Localização",
      selector: r => r.latitude != null && r.longitude != null ? "Localização marcada" : "Não informada",
      sortable: true,
      cell: r => r.latitude != null && r.longitude != null
        ? <a className="text-success text-decoration-none" href={`https://www.openstreetmap.org/?mlat=${r.latitude}&mlon=${r.longitude}#map=16/${r.latitude}/${r.longitude}`} target="_blank" rel="noreferrer"><i className="bi bi-geo-alt-fill me-1" />Ver no mapa</a>
        : <span className="text-muted">Não informada</span>,
    },
    { name: "Propriedade", selector: r => r.propriedadeNome || "-", sortable: true, wrap: true },
    { name: "Agricultor", selector: r => r.agricultorNome || "-", sortable: true, wrap: true },
    { name: "Ativo", selector: r => (r.ativo ? "Sim" : "Não"), sortable: true, width: "120px" },
    {
      name: "Ações",
      cell: row => (
        <div className="d-flex gap-1">
          <button className="btn btn-outline-success btn-sm d-flex align-items-center gap-1" onClick={() => navigate(`/talhoes/editar/${row.id}`)}>
            <i className="bi bi-pencil-square" />
            <span>Editar</span>
          </button>
          <button className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1" onClick={() => navigate(`/mapa-fazenda?propriedadeId=${row.propriedadeId}&talhaoId=${row.id}`)}>
            <i className="bi bi-map" />
            <span>Mapa</span>
          </button>
          <button className="btn btn-outline-danger btn-sm d-flex align-items-center gap-1" onClick={() => handleDelete(row.id)}>
            <i className="bi bi-trash" />
            <span>Excluir</span>
          </button>
        </div>
      ),
      ignoreRowClick: true, allowOverflow: true, button: true, minWidth: "240px", style: { whiteSpace: "nowrap" },
    },
  ];

  return (
    <div className="container mt-4">
      <Header />
      <div className="card shadow-lg border-0 rounded-3">
        <div className="card-header bg-success text-white d-flex justify-content-between align-items-center rounded-top-3">
          <div className="d-flex align-items-center gap-3">
            <button className="btn btn-light btn-sm d-flex align-items-center gap-1" onClick={() => navigate("/menu")}>
              <i className="bi bi-arrow-left text-success" />
              <span className="text-success fw-semibold">Voltar</span>
            </button>
            <div>
              <h5 className="mb-0">Talhões</h5>
              <small className="text-white-50">Gerencie as áreas produtivas</small>
            </div>
          </div>
          <div className="d-flex gap-2">
            <button className="btn btn-light text-success fw-bold d-flex align-items-center gap-1" onClick={() => navigate("/mapa-fazenda")}>
              <i className="bi bi-map" />
              <span>Mapa</span>
            </button>
            <button className="btn btn-light text-success fw-bold d-flex align-items-center gap-1" onClick={() => navigate("/talhoes/novo")}>
              <i className="bi bi-plus-circle" />
              <span>Novo talhão</span>
            </button>
          </div>
        </div>

        <div className="card-body">
          <DataTable
            columns={columns}
            data={rows}
            pagination
            responsive
            highlightOnHover
            striped
            progressPending={loading}
            noDataComponent={<div className="text-muted">Nenhum talhão encontrado.</div>}
          />
        </div>
      </div>
    </div>
  );
};

export default TalhaoList;
